export type SegmentType = (event: string, data: unknown) => void;

export type NewRelicActionAttrType = (
    name: string,
    value: string | boolean | { [key: string]: string | boolean | number }
) => void;

export type NewRelicTrackAjaxType = (
    apiName: string,
    response: unknown,
    success?: boolean,
    additionalInfo?: unknown
) => void;

export type NewRelicTracking = {
    action: NewRelicActionAttrType;
    attribute: NewRelicActionAttrType;
    trackAjax: NewRelicTrackAjaxType;
};

export type AnalyticsTrackType = {
    readonly newRelic: NewRelicTracking;
    readonly segment: SegmentType;
};

export type ProductType = {
    readonly productKey: string;
    readonly productName: string;
};

export type ProductKeysType = {
    product: string;
    edition: string;
    imgSource: string | undefined;
    serverDownloadContent: string | undefined;
    productContent: ProductType[] | undefined;
};
